"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTenantIdFromUrl = void 0;

var getTenantIdFromUrl = function getTenantIdFromUrl() {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('tenantId');
};

exports.getTenantIdFromUrl = getTenantIdFromUrl;